const text = value => typeof value === 'string' ? value.trim() : '';

// Recommendations can include people the listener did not choose. Use the
// selection IDs for membership and ordering; previews only fill missing photos.
export const getOnboardingSelectedSpeakers = ({
    selectedPairs = [], selectedSpeakerIds = [], selectedSpeakers = [], previews = [],
} = {}) => {
    const pairIds = (Array.isArray(selectedPairs) ? selectedPairs : []).map(pair => text(pair?.speakerId)).filter(Boolean);
    const ids = [...new Set((pairIds.length ? pairIds
        : Array.isArray(selectedSpeakerIds) ? selectedSpeakerIds : []).map(text).filter(Boolean))];
    const people = [
        ...(Array.isArray(selectedSpeakers) ? selectedSpeakers : []),
        ...(Array.isArray(previews) ? previews : []).map(preview => preview?.person),
    ];
    return ids.map(id => {
        const matches = people.filter(person => text(person?.id) === id);
        return {
            id,
            name: matches.map(person => text(person.name)).find(Boolean) || '',
            imageURL: matches.map(person => text(person.imageURL)).find(Boolean) || '',
        };
    });
};
